import { render, staticRenderFns } from "./noClass.vue?vue&type=template&id=671c0e52&scoped=true&"
import script from "./noClass.vue?vue&type=script&lang=js&"
export * from "./noClass.vue?vue&type=script&lang=js&"
import style0 from "./noClass.vue?vue&type=style&index=0&id=671c0e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c0e52",
  null
  
)

export default component.exports